export default __webpack_public_path__ + "static/media/delete_Pic.b534c847.svg";